class HomePresenter {
    constructor(useCases, useCaseWebinarShare, useCasesWebinarRegistration, useCaseFeedback, actions) {
        this.useCases = useCases;
        this.useCaseWebinarShare = useCaseWebinarShare;
        this.useCasesWebinarRegistration = useCasesWebinarRegistration;
        this.useCaseFeedback = useCaseFeedback;
        this.actions = actions;
        this.symbols = [];
    }
    async registrationWebinar(payload) {
        return await this.useCasesWebinarRegistration.registrationWebinar(payload);
    }
    // async getHomePageData(): Promise<IHomeAction> {
    //   const homePageData: IHomeEntity = await this.useCases.getHomePageData();
    //   return this.actions.getHomePageData(homePageData);
    // }
    getWebinars() {
        this.actions.webinar.startLoader();
        this.useCases.webinar.execute({
            onSuccess: (data) => {
                this.actions.webinar.getWebinars(data);
                this.actions.webinar.stopLoader();
            },
            onError: (error) => {
                this.actions.webinar.setError({ isOpen: true, error });
                this.actions.webinar.stopLoader();
            },
        }, null);
    }
    getInvestors() {
        this.actions.investor.startLoader();
        this.useCases.investor.execute({
            onSuccess: (data) => {
                this.actions.investor.getInvestor(data);
                this.actions.investor.stopLoader();
            },
            onError: (error) => {
                this.actions.investor.setError({ isOpen: true, error });
                this.actions.investor.stopLoader();
            },
        }, null);
    }
    getMarketNews() {
        this.actions.marketNews.startLoader();
        this.useCases.marketNews.execute({
            onSuccess: (data) => {
                this.actions.marketNews.getMarketNews(data);
                this.actions.marketNews.stopLoader();
            },
            onError: (error) => {
                this.actions.marketNews.setError({ isOpen: true, error });
                this.actions.marketNews.stopLoader();
            },
        }, null);
    }
    getOfferings() {
        this.actions.offerings.startLoader();
        this.useCases.offerings.execute({
            onSuccess: (data) => {
                this.actions.offerings.getAllOfferings(data);
                this.actions.offerings.stopLoader();
            },
            onError: (error) => {
                this.actions.offerings.setError({ isOpen: true, error });
                this.actions.offerings.stopLoader();
            },
        }, null);
    }
    getNewOnEdelweiss() {
        this.actions.newOnEdel.startLoader();
        this.useCases.newOnEdel.execute({
            onSuccess: (data) => {
                this.actions.newOnEdel.getNewOnEdel(data);
                this.actions.newOnEdel.stopLoader();
            },
            onError: (error) => {
                this.actions.newOnEdel.setError({ isOpen: true, error });
                this.actions.newOnEdel.stopLoader();
            },
        }, null);
    }
    getAdBlocks() {
        this.actions.adBlock.startLoader();
        this.useCases.adBlock.execute({
            onSuccess: (data) => {
                this.actions.adBlock.getAdBlock(data);
                this.actions.adBlock.stopLoader();
            },
            onError: (error) => {
                this.actions.adBlock.setError({ isOpen: true, error });
                this.actions.adBlock.stopLoader();
            },
        }, null);
    }
    async shareWebinarByEmail(payload) {
        return await this.useCaseWebinarShare.shareWebinarByEmail(payload);
    }
    async sendFeedback(payload) {
        return await this.useCaseFeedback.sendFeedback(payload);
    }
    getServerKey() {
        this.useCases.serverKey.execute({
            onSuccess: () => { },
            onError: () => { },
        }, null);
    }
}
export default HomePresenter;
